export enum PrintType {
  Message = 'Message',
  Table = 'Table',
}

export class PrintStyle {
  private static styles = {
    [PrintType.Message]: `
      .messages-container {
        width: 100%;
        margin: 60px 0 40px 0;
        font-family: sans-serif;
      }
      .messages-subject {
        background: #efefef;
        padding: 25px 30px;
        text-transform: uppercase;
      }
      .messages-body {
        margin-top: 25px;
        padding: 0 25px;
        font-weight: 300;
        font-size: 12px;
        text-transform: uppercase;
        line-height: 18px;
      }
    `,
    [PrintType.Table]: `
      .requisites-title {
        margin: 60px 0 40px 0;
        text-transform: uppercase;
      }
      .requisites-table {
        width: 100%;
        border-collapse: collapse;
        font-family: sans-serif;
        border: 1px solid #000;
      }
      .requisites-row {
        display: flex;
      }
      .requisites-cell {
        padding: 8px 12px;
        border: 1px solid #000;
      }
      .requisites-cell.header {
        font-weight: bold;
        color: #000;
        text-transform: uppercase;
        font-size: 14px;
        max-width: 200px;
        width: 100%;
      }
      .requisites-cell:not(.header) {
        font-weight: normal;
        color: #000;
        text-transform: uppercase;
        font-size: 14px;
        flex-grow: 1;
        text-align: right;
      }
    `,
  };

  static getStyle(printType: PrintType): string {
    return `
      @page {
        size: auto;
        margin: 0;
      }
      .header-container {
        width: 100%;
        background: #f8f8f8;
        height: 130px;
        margin-bottom: 20px;
        font-family: sans-serif;
      }
      .header-content {
        display: flex;
        height: 100%;
        justify-content: space-between;
        align-items: center;
        padding: 0 40px 0 130px;
      }
      .header-logo {
        font-size: 24px;
        font-weight: bold;
        text-transform: uppercase;
      }
      .header-support-text {
        display: flex;
        align-items: center;
        font-weight: 500;
        text-transform: uppercase;
        padding-right: 25px;
        border-right: 2px solid #cc3434;
        height: 66px;
        font-size: 16px;
        color: #444444;
        text-align: right;
      }
      .header-children {
        margin-top: 20px;
        padding: 0 70px;
      }
      ${this.styles[printType]}
    `;
  }
}
